export default "__VITE_ASSET__WEnhiDIS__"